module.exports = __webpack_public_path__ + "static/media/EditGreen.a4656423.svg";